module.exports = __webpack_public_path__ + "static/media/connectedWithUserBlack.9164cf15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/connectedWithUserBlack.svg
// module id = 1935
// module chunks = 0